/**
 * name: productsList.js
 * description: 전역으로 사용될 제품목록
 */
 export const MAIN_PRODUCTS_LIST = [
  {
    id: 1,
    name: '인셀덤 더마톨로지 퍼스트 패키지 EX',
    desc: '피부 속까지 환한 빛을 깨우다',
    hash: '#더마톨로지퍼스트패키지EX #인셀덤 #INCELLDERM',
    img: 'product_main01.jpg',
  },
  {
    id: 2,
    name: '인셀덤 엑티브 크림 EX',
    desc: '탄탄한 피부로 가꾸어 주는 탄력 보습 크림',
    hash: '#엑티브크림EX #인셀덤 #INCELLDERM_of_the_day',
    img: 'product_main02.jpg',
  },
  {
    id: 4,
    name: '인셀덤 발라또 오일미스트',
    desc: '피부를 숨 쉬게 하고 빼앗긴 수분을 되찾다',
    hash: '#오일미스트 #인셀덤 #프리미엄케어 #발라또오일미스트',
    img: 'product_main04.jpg',
  },
  {
    id: 3,
    name: '인셀덤 카밍 밸런스 젤',
    desc: '금 성분 함유로 피부에 고요의 시간을 선물합니다',
    hash: '#카밍밸런스젤 #인셀덤 #피부밸런스',
    img: 'product_main03.jpg',
  },
  {
    id: 9,
    name: '인셀덤 스노우 엔자임 클렌저',
    desc: '피부를 맑고 깨끗하게 가꾸어주는 효소 클렌저',
    hash: '#스노우엔자임클렌저 #인셀덤 #클렌저',
    img: 'product_main09.jpg',
  },
  {
    id: 8,
    name: '인셀덤 엑티브 클린업 파우더',
    desc: '피부 노폐물을 지우고 깨끗해진 피부에 수분을 담아줍니다.',
    hash: '#인셀덤 #엑티브클린업파우더 #피부수분',
    img: 'product_main08.jpg',
  },
  {
    id: 5,
    name: '인셀덤 아쿠아 프로텍션 선 젤',
    desc: '피부 수분 보호막을 형성하는데 도움이 됩니다.',
    hash: '#자외선차단 #아쿠아프로텍션선젤 #인셀덤',
    img: 'product_main05.jpg',
  },
  {
    id: 6,
    name: '인셀덤 데일리 아쿠아 비비',
    desc: '비비, 한 겹의 피부로 진화하다.',
    hash: '#비비크림 #인셀덤 #데일리아쿠아비비',
    img: 'product_main06.jpg',
  },
  {
    id: 7,
    name: '인셀덤 4D 러스터 쿠션',
    desc: '어떤 각도에서나 자연스러운 광채 피부를 연출합니다.',
    hash: '#4D러스터쿠션 #광채쿠션 #인셀덤',
    img: 'product_main07.jpg',
  },

];

export const PRODUCTS = [
  {
    id: 1,
    name: '인셀덤 더마톨로지 퍼스트 패키지 EX',
    desc01: 'INCELLDERM DERMATOLOGY FIRST PACKAGE EX',
    desc02: '피부 속까지 환한 빛을 깨우다',
    url: '',
    ment: '외부환경으로부터 피부를 보호하고 깊은 영양을 부여해<span class=\'brs\'></span> 건강하고 빛나는 피부로 케어해주는 부스터, 세럼 패키지',
    info01: '더마톨로지 부스터 EX 130ml / 4.39 fl.oz.<br>더마톨로지 세럼 EX 45ml / 1.52 fl.oz.',
    info02: '미백/주름개선 2중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main01.png'],
    detailimg: 'product_detail01',
  },
  {
    id: 2,
    name: '인셀덤 엑티브 크림 EX',
    desc01: 'INCELLDERM ACTIVE CREAM EX',
    desc02: '피부가 가장 엑티브해지는 순간',
    url: '',
    ment: '피부 깊은 보습과 영양감을 채워 기초부터 탄탄한 피부로 <br>케어해주는 장벽 케어 보습 크림',
    info01: '50ml / 1.69 fl.oz.',
    info02: '미백/주름개선 2중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main02.png'],
    detailimg: 'product_detail02',
  },
  {
    id: 4,
    name: '인셀덤 발라또 오일미스트',
    desc01: 'INCELLDERM VALLATTO OIL MIST',
    desc02: '피부 속에서 광채를 밝히다',
    url: '',
    ment: '오일의 보습감과 비타민의 영양감을 가득 채워 즉각적으로 <span class=\'brs\'></span>빛나는 광채 피부를 선사하는  황금비율의 고보습 오일 미스트',
    info01: '50ml/ 1.69 fl.oz.',
    info02: '미백/주름개선 2중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main04.png'],
    detailimg: 'product_detail04',
  },
  {
    id: 3,
    name: '인셀덤 카밍 밸런스 젤',
    desc01: 'INCELLDERM CALMING BALANCE GEL',
    desc02: '언제 어디서나 수분 진정, 멀티 보습 힐링젤',
    url: '',
    ment: '다마스크꽃수와 유기농 카밍 성분이 민감해진 피부의 유수분 <span class=\'brs\'></span>밸런스를 맞추어 피부에 편안함을 선사하는 수분 진정 젤',
    info01: '100ml / 3.38 fl.oz.',
    info02: '.',
    info03: '모든 피부',
    thumbnail: ['product_main03.png'],
    detailimg: 'product_detail03',
  },
  {
    id: 9,
    name: '인셀덤 스노우 엔자임 클렌저',
    desc01: 'INCELLDERM SNOW ENZYME CLEANSER',
    desc02: '피부를 맑고 깨끗하게 가꾸어주는 효소 클렌저 ',
    url: '',
    ment: '눈과 같은 부드럽고 도톰한 질감의 거품이 피부를 산뜻하게 세정하고<br>피부를 맑고 깨끗하게 가꾸어주는 효소 클렌저',
    info01: '120g / 4.23 oz.',
    info02: '.',
    info03: '모든 피부',
    thumbnail: ['product_main09.png'],
    detailimg: 'product_detail09',
  },
  {
    id: 8,
    name: '인셀덤 엑티브 클린업 파우더',
    desc01: 'INCELLDERM ACTIVE CLEAN-UP POWDER',
    desc02: '피부를 지키는 세안 테라피',
    url: '',
    ment: '식물에서 유래한 파파인이 피부의 묵은 각질과 노폐물을<br>깨끗이 세정하여 피부톤을 맑고 깨끗하게 가꾸어줍니다.',
    info01: '90g / 3.17 oz.',
    info02: '.',
    info03: '모든 피부',
    thumbnail: ['product_main08.png'],
    detailimg: 'product_detail08',
  },

  {
    id: 5,
    name: '인셀덤 아쿠아 프로텍션 선 젤',
    desc01: 'INCELLDERM AQUA PROTECTION SUN GEL',
    desc02: '빛 샐 틈 없는 수분 방어막',
    url: '',
    ment: '자작나무수액이 수분 보호막을 형성해 피부 진정과 보습까지 케어해주며,<br>자외선으로부터 피부를 보호해 건강한 피부로 가꾸어주는 수분 선 젤',
    info01: '50ml / 1.69 fl.oz.',
    info02: '자외선차단/미백/주름개선 3중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main05.png'],
    detailimg: 'product_detail05',
  },
  {
    id: 6,
    name: '인셀덤 데일리 아쿠아 비비',
    desc01: 'INCELLDERM DAILY AQUA BB',
    desc02: '비비, 한 겹의 피부로 진화하다',
    url: '',
    ment: '부드럽고 촉촉하게 스며들어 피부 본연의 빛을 밝혀주며<span class=\'brs\'></span>매끄럽고 아름다운 피부를 완성시켜주는 데일리 비비크림',
    info01: '30g / 1.05 oz.',
    info02: '미백/주름개선 2중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main06.png'],
    detailimg: 'product_detail06',
  },
  {
    id: 7,
    name: '인셀덤 4D 러스터 쿠션',
    desc01: 'INCELLDERM 4D LUSTRE CUSHION',
    desc02: "피부 광학의 절정 '본연의 속 빛을 밝히다'",
    url: '',
    ment: '촉촉한 수분 베이스로 보습감을 유지하며 깨끗하고 화사한 <br>메이크업을 완성시켜주는 수분 광채 쿠션',
    info01: '15g (0.53oz.) * 2ea',
    info02: '자외선차단/미백/주름개선 3중 기능성',
    info03: '모든 피부',
    thumbnail: ['product_main07.png'],
    detailimg: 'product_detail07',
  },

];
export const RECOMMENDED_PRODUCTS = ['스노우', '발라또', '엑티브', '카밍', '러스터'];

export default {
  PRODUCTS, RECOMMENDED_PRODUCTS, MAIN_PRODUCTS_LIST,
};
